/* unplugin-vue-components disabled */import { render } from "./PopupFollowOfficialAccounts.vue?vue&type=template&id=e9d56234&ts=true"
import script from "./PopupFollowOfficialAccounts.vue?vue&type=script&lang=ts"
export * from "./PopupFollowOfficialAccounts.vue?vue&type=script&lang=ts"

import "./PopupFollowOfficialAccounts.vue?vue&type=style&index=0&id=e9d56234&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__